var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnglish(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 71.992,
    height: 48.109,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "english_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2633",
    d: "M0 0h47.959v71.937H0z",
    transform: "rotate(-90.066 -3705.469 3935.35)",
    fill: "#f0f0f0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2475"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2615",
    d: "M.056 48.109L0 .097 71.937.014l.055 48.012z",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Mask Group 4",
    transform: "translate(7645.139 -186.375)",
    clipPath: "url(#english_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2297"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2296"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2294"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2616",
    d: "M-7604.673 186.394l-8.994.014.028 19.486-31.479.045.013 8.993 31.479-.044.027 19.487 8.994-.012-.028-19.488 31.48-.045-.013-8.993-31.48.044z",
    fill: "#ff505c"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2291"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2617",
    d: "M-7589.774 218.707l16.626 9.206-.013-9.23z",
    fill: "#5f40d4"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2618",
    d: "M-7601.316 218.724l28.177 15.601-.006-4.423-20.21-11.189z",
    fill: "#0052b4"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2619",
    d: "M-7580.639 234.336l-20.67-11.447.015 11.477z",
    fill: "#5f40d4"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2620",
    d: "M-7601.316 218.727l28.177 15.601-.006-4.423-20.21-11.189z",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2621",
    d: "M-7601.316 218.727l28.177 15.601-.006-4.423-20.21-11.189z",
    fill: "#ff505c"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2292",
    fill: "#5f40d4"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2622",
    d: "M-7632.41 218.754l-12.683 7.073-.01-7.053z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2623",
    d: "M-7616.946 220.723l.018 13.65-24.57.037z"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2624",
    d: "M-7624.914 218.745l-20.176 11.247.006 4.424 28.133-15.682z",
    fill: "#ff505c"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2293"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2625",
    d: "M-7628.505 202.072l-16.626-9.206.013 9.23z",
    fill: "#5f40d4"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2626",
    d: "M-7616.964 202.056l-28.176-15.602.006 4.423 20.209 11.19z",
    fill: "#0052b4"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2627",
    d: "M-7637.64 186.443l20.671 11.447-.013-11.472z",
    fill: "#5f40d4"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2628",
    d: "M-7616.964 202.058l-28.176-15.602.006 4.424 20.209 11.19z",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2629",
    d: "M-7616.964 202.058l-28.176-15.602.006 4.424 20.209 11.19z",
    fill: "#ff505c"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2295",
    fill: "#5f40d4"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2630",
    d: "M-7585.871 202.024l12.685-7.07.008 7.05z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2631",
    d: "M-7601.333 200.058l-.02-13.653 24.57-.037z"
  }))), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2632",
    d: "M-7593.374 202.034l20.18-11.248-.005-4.423-28.136 15.683z",
    fill: "#ff505c"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnglish);
export default __webpack_public_path__ + "static/media/english.e634497952e1a43521b4bc7ea9d17c4e.svg";
export { ForwardRef as ReactComponent };